export type UserAccessProfile = 'SDR' | 'GERENTE' | 'SUPERVISOR' | 'ADMIN';
export type UserStatus = 'ACTIVE' | 'INACTIVE';

export interface PlatformUser {
  id: string;
  name: string;
  email: string;
  profile: UserAccessProfile;
  status: UserStatus;
  created_at: string;
  updated_at: string;
}

export interface CreatePlatformUserInput {
  name: string;
  email: string;
  profile: UserAccessProfile;
}

export interface UpdatePlatformUserInput extends CreatePlatformUserInput {
  status: UserStatus;
}

export const USER_ACCESS_PROFILES: UserAccessProfile[] = [
  'SDR',
  'GERENTE',
  'SUPERVISOR',
  'ADMIN',
];

export const USER_ACCESS_PROFILE_LABELS: Record<UserAccessProfile, string> = {
  SDR: 'SDR',
  GERENTE: 'Gerente',
  SUPERVISOR: 'Supervisor',
  ADMIN: 'Admin',
};

export const USER_STATUS_LABELS: Record<UserStatus, string> = {
  ACTIVE: 'Ativo',
  INACTIVE: 'Inativo',
};
